import haversine from 'haversine';
export const isUnderLocation = (start, end, radius) => {
  let meters = haversine(start, end, { unit: 'meter' });
  return haversine(start, end, { threshold: radius + 100, unit: 'meter' });
};
